import { PartialTranslation } from '../translations';

export const sv: PartialTranslation = {
  newChat: 'Ny chatt',
  search: 'Sök',
  user: 'Användare',
  settings: 'Inställningar',
  language: 'Språk',
  getHelp: 'Få hjälp',
  viewAllPlans: 'Visa alla planer',
  learnMore: 'Lär dig mer',
  logOut: 'Logga ut',
  chooseLanguage: 'Выберите язык',
  chooseYourPreferredLanguage: 'Выберите предпочитаемый язык',
  searchLanguages: 'Поиск языков...',
  autoDetect: 'Automatisk upptäckt',
  noLanguagesFound: 'Языки не найдены',
  askAnything: 'Fråga vad som helst',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personlig',
  freePlan: 'Gratis plan',
  current: 'Текущий',
  close: 'Закрыть',
  archive: 'Архивировать',
  delete: 'Удалить',
  confirmDelete: 'Вы уверены, что хотите удалить этот чат?',
  confirmArchive: 'Вы уверены, что хотите архивировать этот чат?',
  deleteCannotUndo: 'Это действие нельзя отменить.',
  archiveCanFind: 'Вы сможете найти его в списке архива после архивирования.',
  
  // 资源面板
  resources: 'Resurser',
  addResource: 'Lägg till resurs',
  deleteResource: 'Удалить ресурс',
  noMatchingResourcesFound: 'Подходящие ресурсы не найдены',
  noResourcesAvailable: 'Ресурсы недоступны',
  hideResources: 'Скрыть ресурсы',
  showResources: 'Показать ресурсы',
  
  // 聊天输入框
  typeMessage: 'Skriv ett meddelande...',
  thinkingOptions: 'Варианты размышления',
  deleteFile: 'Удалить файл',
  clearSelection: 'Очистить выбор',
  addAttachment: 'Lägg till bilaga',
  sendMessage: 'Skicka meddelande',
  
  // 思考模式选项
  deepInsight: 'Глубокое понимание · Поверхностный анализ',
  deepInsightDesc: 'Быстрое понимание ключевых моментов',
  deepExploration: 'Глубокое исследование · Комплексный анализ',
  deepExplorationDesc: 'Многомерное углубленное исследование',
  deepDeconstruction: 'Глубокая деконструкция · Систематический аргумент',
  deepDeconstructionDesc: 'Послойный прогрессивный анализ',
  
  // 写作模式选项
  contractReview: 'Обзор контракта · Выявление рисков',
  contractReviewDesc: 'Анализ пунктов и проверка соответствия',
  textPolish: 'Полировка текста · Профессиональное выражение',
  textPolishDesc: 'Языковая оптимизация и структурная настройка',
  legalDocuments: 'Правовые документы · Стандартный проект',
  legalDocumentsDesc: 'Профессиональное написание правовых документов',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Logga in',
  register: 'Registrera dig',
  welcomeBack: 'Välkommen till LawHelper',
  loginSubtitle: 'Din AI Juridiska Forskningsassistent',
  continueWithGoogle: 'Fortsätt med Google',
  continueWithMicrosoft: 'Fortsätt med Microsoft',
  continueWithWeChat: 'Fortsätt med WeChat',
  orContinueWith: 'eller fortsätt med',
  emailTab: 'E-post',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Ange din e-post',
  phonePlaceholder: 'Ange telefonnummer',
  codePlaceholder: 'Ange 6-siffrig kod',
  sending: 'Skickar...',
  verifying: 'Verifierar...',
  verify: 'Verifiera',
  sendMagicLink: 'Skicka magisk länk',
  getVerificationCode: 'Hämta kod',
  resendCode: 'Skicka kod igen',
  resendIn: 'Skicka igen om',
  magicLinkSent: 'Magisk länk skickad till din e-post',
  magicLinkHint: 'Vi skickar en säker länk till din e-post',
  otpSent: 'Verifieringskod skickad',
  agreeToTerms: 'Genom att fortsätta godkänner du våra',
  privacyPolicy: 'Integritetspolicy',
  termsOfService: 'Användarvillkor',
  and: 'och',
  privacyTitle: 'Din integritet är viktig',
  privacyIntro: 'Vi använder cookies och liknande tekniker för att ge dig den bästa upplevelsen.',
  essentialCookies: 'Nödvändiga cookies',
  essentialDesc: 'Krävs för att webbplatsen ska fungera',
  analyticsCookies: 'Analytiska cookies',
  analyticsDesc: 'Hjälper oss att förbättra vår tjänst',
  marketingCookies: 'Marknadsföringscookies',
  marketingDesc: 'Används för personligt innehåll',
  acceptAll: 'Acceptera alla',
  essentialOnly: 'Endast nödvändiga',
  customize: 'Anpassa',
  savePreferences: 'Spara inställningar',
  back: 'Tillbaka',
  readPrivacyPolicy: 'Läs vår integritetspolicy',
  cookiePolicy: 'Cookiepolicy',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI-granskning',
  aiDraft: 'AI-utkast',
  smartAssistant: 'Mall',

  // 知识库搜索
  enableKnowledgeSearch: 'Aktivera sökning',
  knowledgeSearchDesc: 'AI söker i dina dokument',
  clickToDisable: 'Inaktivera',
  clickToEnable: 'Aktivera',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Stäng resurspanel',
  uploading: 'Laddar upp %{fileName}...',
  processing: 'Bearbetar %{fileName}...',
  uploadSuccess: '✓ %{fileName} uppladdad',
  uploadError: '✗ Uppladdning misslyckades: %{error}',
  quickAnswer: 'Snabbt svar',
  quickAnswerDesc: 'Snabbt svar på enkla frågor',
  cancelRequest: 'Avbryt',
  library: 'Bibliotek',
  filterAll: 'Alla',
  filterChat: 'Chattar',
  filterReview: 'Granskning',
  filterDraft: 'Utkast',
  filterTemplate: 'Mall',
  filterForm: 'Formulär',
  thinking: 'Tänker...',
  thinkingProcess: 'Tankeprocess',
  analyzingLegalLogic: 'Analyserar juridisk logik...',
  lawhelperThinking: 'Lawhelper tänker...',
  serviceError: 'Tjänstefel',
  uploaded: 'Uppladdat',
  settingsGeneral: 'Allmänt',
  settingsNotifications: 'Aviseringar',
  settingsAppearance: 'Utseende',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Svarsaviseringar',
  settingsResponseNotificationsDesc: 'Avisering när AI slutfört svaret',
  settingsColorMode: 'Färgläge',
  settingsLight: 'Ljust',
  settingsDark: 'Mörkt',
  settingsSystem: 'System',
  about: 'Om',
  reviewTitle: 'Dokumentgranskning',
  exitReview: 'Avsluta granskning',
  uploadPrompt: 'Ladda upp PDF för granskning',
  uploadButton: 'Välj fil',
  startChatConfig: 'Skriv "Granska detta dokument" för att börja',
  reviewPlaceholder: 'Skriv ett meddelande eller "Granska detta dokument"...',
  analyzing: 'Granskar...',
  reviewComplete: 'Granskning klar',
  issuesFound: '%{count} problem hittade',
  draftTitle: 'Rättslig dokumentuppsättning',
  draftPlaceholder: 'Redigera här eller låt AI generera...',
  analyzingTemplate: 'Analyserar mall %{name}...',
  templateAnalyzed: '✅ Mall %{name} analyserad! Berätta hur du vill ändra den.',
  templateAnalysisPrompt: 'Analysera nyckelklausuler i mallen',
  parsingFailed: '⚠️ Kunde inte analysera filen, men du kan beskriva dina behov.',
  generating: 'Genererar...',
  generatedSuccess: '✅ Dokument genererat! Visa och redigera i editorn.',
  drafterWelcome: 'Välkommen till AI-dokumentassistenten',
  drafterYouCan: 'Du kan:',
  drafterUploadTemplate: 'Ladda upp en mall för AI-analys',
  drafterDescribeNeeds: 'Beskriv dina dokumentkrav',
  drafterLetAiHelp: 'AI hjälper dig att skriva kontrakt, avtal m.m.',
  drafterExamples: 'Exempel:',
  drafterExampleRental: '"Skriv ett hyresavtal"',
  drafterExampleLabor: '"Fyll i arbetsavtalet enligt mallen"',
  drafterInputPlaceholder: 'Beskriv dina dokumentbehov...',
  drafterThinking: 'Tänker...',
  drafterHistoryTitle: 'Historik',
  drafterNoHistory: 'Ingen historik',
  drafterNewChat: 'Ny chatt',
  drafterHistory: 'Historik',
  drafterRemoveAttachment: 'Ta bort bilaga',
  drafterLineHeight: 'Radhöjd',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Exportera som Word (.docx)',
  drafterExportPdf: 'Exportera som PDF',
  drafterSave: 'Spara dokument',
  drafterDownload: 'Ladda ner dokument',
  drafterUndo: 'Ångra',
  drafterRedo: 'Gör om',
  drafterBold: 'Fet',
  drafterItalic: 'Kursiv',
  drafterStrike: 'Genomstruken',
  drafterUnderline: 'Understruken',
  drafterHighlight: 'Markera',
  drafterLink: 'Infoga länk',
  drafterAlignLeft: 'Vänsterjustera',
  drafterAlignCenter: 'Centrera',
  drafterAlignRight: 'Högerjustera',
  drafterAlignJustify: 'Marginaljustera',
  drafterList: 'Lista',
  drafterBulletList: 'Punktlista',
  drafterOrderedList: 'Numrerad lista',
  drafterTaskList: 'Uppgiftslista',
  drafterOpenResource: 'Öppna resurspanel',
  drafterStopGeneration: 'Stoppa generering',
  drafterAgentMode: 'Agentläge aktivt | Klicka för vanlig chatt',
  drafterAgentModeOn: 'Agentläge aktivt | Klicka för vanlig chatt',
  drafterAgentModeOff: 'Vanligt chattläge | Klicka för agentläge',
  drafterUploadAttachment: 'Ladda upp bilaga',
  drafterExit: 'Avsluta',
  drafterConfirm: 'Bekräfta',
  drafterOpenLink: 'Öppna länk',
  drafterDeleteLink: 'Ta bort länk',
  drafterQuote: 'Citat',
  workflowTitle: 'AI-arbetsflöde',
  workflowRunning: 'Körs...',
  workflowReady: 'Redo',
  workflowCompleted: 'Slutfört',
  workflowStartFailed: 'Arbetsflöde kunde inte startas',
  workflowExecutionFailed: 'Arbetsflöde misslyckades',
  workflowInterrupted: 'Arbetsflöde avbrutet',
  workflowProcessing: 'Bearbetar...',
  workflowStepsCompleted: 'steg slutförda',
  workflowStepsTotal: 'Arbetsflöde slutfört (%{count} steg)',
  acceptChanges: 'Acceptera ändringar',
  rejectChanges: 'Avvisa ändringar',
  changesAccepted: 'Ändringar accepterade',
  changesRejected: 'Ändringar avvisade',
  stopWorkflow: 'Stoppa',
  restartWorkflow: 'Starta om',
  startDrafting: 'Börja skriva',
  interrupt: 'Stoppa',
  documentSubject: 'Dokumentämne *',
  documentType: 'Dokumenttyp',
  jurisdiction: 'Jurisdiktion',
  specialRequirements: 'Särskilda krav (valfritt)',
  clickStartDrafting: 'Klicka "Börja skriva" för att starta',
  docTypeContract: 'Kontrakt',
  docTypeAgreement: 'Avtal',
  docTypeNotice: 'Meddelande',
  docTypeLetter: 'Brev',
  docTypePetition: 'Petition',
  docTypeWill: 'Testamente',
  docTypePowerOfAttorney: 'Fullmakt',
  countryChina: 'Kina',
  countryUSA: 'USA',
  countryGermany: 'Tyskland',
  countryJapan: 'Japan',
  countryFrance: 'Frankrike',
  countryUK: 'Storbritannien',
  citationVerified: 'Verifierad',
  citationUnverified: 'Ej verifierad',
  imageLoadFailed: 'Bilden kunde inte laddas',
  smartDocTitle: 'Smart dokumentassistent',
  smartDocChatTitle: 'AI-dokumentassistent',
  smartDocDropPrompt: 'Släpp PDF-fil här',
  smartDocSelectFile: 'Välj fil',
  smartDocOr: 'eller',
  smartDocWelcomeTitle: 'Välkommen till AI-dokumentassistenten',
  smartDocWelcomeYouCan: 'Du kan:',
  smartDocUploadForAI: 'Ladda upp mall för AI-analys',
  smartDocDescribeDoc: 'Beskriv dokumentkrav',
  smartDocLetAIDraft: 'AI hjälper med kontrakt',
  smartDocExamples: 'Exempel:',
  smartDocExampleRental: '"Skriv ett hyresavtal"',
  smartDocExampleLabor: '"Fyll i arbetsavtalet"',
  smartDocInputPlaceholder: 'Beskriv dina dokumentbehov...',
  smartDocRemoveAttachment: 'Ta bort bilaga',
  smartDocOpenResources: 'Öppna resurspanel',
  smartDocExit: 'Avsluta',
  reviewStartFailed: 'Granskningsarbetsflöde misslyckades',
  reviewFailed: 'Granskning misslyckades',
  reviewFoundIssues: 'Granskning klar, %{count} problem hittade.',
  cannotReadStream: 'Kan inte läsa svarsströmmen',
  parseEventFailed: 'Kunde inte analysera händelse',
  errorPrefix: 'Fel',
  unknownError: 'Okänt fel',
  file: 'Fil',
  loading: 'Laddar...',
  localFolders: 'Lokala mappar',
  selectLocalFolder: 'Välj lokal mapp',
  reselectFolder: 'Byt mapp',
  addToContext: 'Lägg till i chatt',
  saveFile: 'Spara',
  renameFile: 'Byt namn',
  fileSaved: 'Fil sparad',
  fileRenamed: 'Fil omdöpt till %{name}',
  browserNotSupported: 'Din webbläsare stöder inte lokal mappåtkomst',
  noFolderSelected: 'Välj en lokal mapp för att bläddra',
  scanningFolder: 'Skannar mapp...',
  selectFileToPreview: 'Välj fil för förhandsgranskning',
  aiAnalyze: 'AI-analys',
};
